import { createContext, ReactNode, useContext } from 'react';

import {
  AssessmentActionsResult,
  useAssessmentActions,
} from '~/lib/hooks/useAssessmentActions';

const AssessmentActionsContext = createContext<AssessmentActionsResult | null>(
  null,
);

interface AssessmentActionsProviderProps {
  children: ReactNode;
  patientId: string;
}

export const AssessmentActionsProvider = ({
  children,
  patientId,
}: AssessmentActionsProviderProps) => {
  const assessmentActions = useAssessmentActions(patientId);

  return (
    <AssessmentActionsContext.Provider value={assessmentActions}>
      {children}
    </AssessmentActionsContext.Provider>
  );
};

export const useAssessmentActionsContext = (): AssessmentActionsResult => {
  const context = useContext(AssessmentActionsContext);
  if (!context) {
    throw new Error(
      'useAssessmentActionsContext must be used within an AssessmentActionsProvider',
    );
  }
  return context;
};
